/**
 * La Review Section JavaScript
 * Handles carousel functionality for review section
 * Mobile: 1 slide, Medium (768px): 2 slides, Large (1024px+): 3 slides
 */

(function () {
    'use strict';

    const processedSections = new Set();

    function initLaReviewSlider(sliderElement) {
        if (processedSections.has(sliderElement)) return;

        const swiperContainer = sliderElement.querySelector('.swiper-container');
        if (!swiperContainer) return;

        // Check if Swiper library is available
        if (typeof MinimogLibs === 'undefined' || !MinimogLibs.Swiper) {
            // Try again after a delay
            setTimeout(function () { initLaReviewSlider(sliderElement); }, 100);
            return;
        }

        // Mark as processed
        processedSections.add(sliderElement);

        // Find navigation and pagination elements
        const section = sliderElement.closest('section');
        const nextButton = sliderElement.querySelector('.m-slider-controls__button-next') ||
            (section && section.querySelector('.m-slider-controls__button-next'));
        const prevButton = sliderElement.querySelector('.m-slider-controls__button-prev') ||
            (section && section.querySelector('.m-slider-controls__button-prev'));
        const paginationEl = sliderElement.querySelector('.swiper-pagination') ||
            (section && section.querySelector('.swiper-pagination'));

        // Get autoplay setting
        const autoplay = sliderElement.dataset.autoplay === 'true';

        // Create Swiper instance
        const swiper = new MinimogLibs.Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: false,
            allowTouchMove: true,
            simulateTouch: true,
            watchOverflow: true,
            observer: true,
            observeParents: true,
            autoplay: autoplay ? {
                delay: 5000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false
            } : false,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                    allowTouchMove: true,
                    simulateTouch: true
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                    allowTouchMove: true,
                    simulateTouch: true
                }
            },
            navigation: (nextButton && prevButton) ? {
                nextEl: nextButton,
                prevEl: prevButton
            } : false,
            pagination: paginationEl ? {
                el: paginationEl,
                clickable: true
            } : false,
            on: {
                init: function () {
                    setTimeout(function () {
                        window.dispatchEvent(new Event('resize'));
                    }, 100);
                }
            }
        });

        // Store reference on the container
        swiperContainer.swiper = swiper;

        // Add direct click handlers as fallback for navigation
        if (nextButton) {
            nextButton.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (swiperContainer.swiper) {
                    swiperContainer.swiper.slideNext();
                }
            });
        }

        if (prevButton) {
            prevButton.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (swiperContainer.swiper) {
                    swiperContainer.swiper.slidePrev();
                }
            });
        }
    }

    function initAllLaReviewSliders() {
        const sliderElements = document.querySelectorAll('[data-la-review="true"]');

        sliderElements.forEach(function (sliderElement) {
            initLaReviewSlider(sliderElement);
        });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            setTimeout(initAllLaReviewSliders, 300);
        });
    } else {
        setTimeout(initAllLaReviewSliders, 300);
    }

    // Re-initialize for Shopify theme editor
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', function (event) {
            processedSections.clear();
            setTimeout(initAllLaReviewSliders, 300);
        });
    }

    // Handle resize
    let resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            const sliderElements = document.querySelectorAll('[data-la-review="true"]');
            sliderElements.forEach(function (el) {
                const swiperContainer = el.querySelector('.swiper-container');
                if (swiperContainer && swiperContainer.swiper) {
                    swiperContainer.swiper.update();
                }
            });
        }, 250);
    });
})();
